/**
 * Analytics events (PRD §12), forwarded to every configured sink: Google Analytics (lib/ga.ts,
 * consent-aware) and PostHog when its key is set (lib/monitoring.ts). Events are also logged in
 * development so the funnel can be checked without a key.
 */
export type EventName =
  | 'round_started'
  | 'guess_where_locked'
  | 'guess_submitted'
  | 'round_completed'
  | 'share_clicked'
  | 'share_image'
  | 'challenge_shared'
  | 'challenge_opened'
  | 'leaderboard_viewed'
  | 'stats_viewed'
  | 'name_set'
  | 'practice_started'
  | 'practice_completed'
  | 'group_created'
  | 'group_joined'
  | 'device_linked'
  | 'install_prompted'
  | 'data_deleted'
  | 'question_reported'
  | 'reminder_enabled'
  | 'reminder_disabled'
  | 'digest_subscribed'
  | 'digest_unsubscribed';

export type Props = Record<string, string | number | boolean | null>;
type Sink = (event: EventName, props?: Props) => void;

const sinks: Sink[] = [];

export function addAnalyticsSink(fn: Sink): void {
  sinks.push(fn);
}

export function track(event: EventName, props?: Props): void {
  if (import.meta.env.DEV) console.debug('[analytics]', event, props ?? {});
  for (const sink of sinks) {
    try {
      sink(event, props);
    } catch {
      /* analytics must never break the game */
    }
  }
}
